import React from "react";
import { FormSectionProps } from "./type";

const AddressContactSection: React.FC<FormSectionProps> = ({
  formData,
  onFormDataChange,
}) => {
  return (
    <div className="space-y-4">
      {/* Bank Address */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Bank Address
        </label>
        <textarea
          name="bankAddress"
          value={formData.details.bankAddress}
          onChange={(e) =>
            onFormDataChange("bankAddress", e.target.value, true)
          }
          placeholder="Complete bank branch address"
          rows={3}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#000200] resize-none"
          required
        />
      </div>

      {/* Contact Number */}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Contact Number
        </label>
        <input
          type="tel"
          name="contactNumber"
          value={formData.details.contactNumber}
          onChange={(e) =>
            onFormDataChange("contactNumber", e.target.value, true)
          }
          placeholder="Bank branch contact number"
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#000200]"
          required
        />
      </div>
    </div>
  );
};

export default AddressContactSection;
